import axios from "axios";

import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// DAILY ISSUE VERIFICATION RELATED APIs
// ==============================================

// 1. Get Daily Issue Grid for Verification by Role ID, Created Date and User ID
export const getVerifyDailyIssueGrid = async (roleId, created, userId) => {
    try {
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/Purchase/VerifyDailyIssueGrid?Roleid=${roleId}&Created=${created}&Userid=${userId}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 2. Get Daily Issue Details by Transaction Number and Cost Center Code
export const getDailyIssueDetails = async (tranNo, ccCode) => {
    try {
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/Purchase/GetDailyIssueDetails?TranNo=${tranNo}&CCCode=${ccCode}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 3. Get Daily Issue Remarks by Reference Number
export const getDailyIssueRemarks = async (refNo) => {
    try {
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/Purchase/GetDailyIssueRemarks?Refno=${refNo}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};


// 4. Approve Daily Issue
export const approveDailyIssue = async (approvalData) => {
    try {
        
        const response = await axios.put(
            `${API_BASE_URL}/Purchase/ApproveDailyIssue`,
            approvalData,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                timeout: 30000
            }
        );
        
        return response.data;
        
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};